import { useEffect, useRef, useState } from 'react';
import { DnDProps, SortableElementProps } from './utils/types';
import { registerSortable } from './utils/refManager';

export const useSortableElement = <Props extends Record<string, any>>({
  index,
  collection,
  isDisabled,
  style,
  dragTargetClass,
  ...compProps
}: Props & SortableElementProps) => {
  const ref = useRef<HTMLElement | null>(null);
  const [
    { componentStyle, ghostStyle, ghostContainer, onTransitionEnd },
    setState,
  ] = useState<DnDProps>({});
  const mergedStyle =
    style && componentStyle
      ? { ...style, ...componentStyle }
      : style || componentStyle || null;
  const mergedGhostStyle = ghostStyle
    ? { ...(style || {}), ...ghostStyle }
    : null;
  useEffect(
    () =>
      registerSortable(
        ref,
        { index, collection, isDisabled, dragTargetClass },
        setState
      ),
    [ref, index, collection, isDisabled, dragTargetClass, setState]
  );

  return {
    ghostContainer,
    onTransitionEnd,
    mergedStyle,
    mergedGhostStyle,
    compProps,
    ref,
    ghostStyle,
    dragTargetClass,
  };
};
